module.exports = __webpack_public_path__ + "img/product3-1.918d9dba.png";